import { OfferGroupResponse } from '~client/model/offer-group-response';
import { SecondaryExchangeOfferGroupRequest } from '~client/model/secondary-exchange-offer-group-request';
import { rxTask } from '~common/helper/mobx-tasks';
import { apiClient } from '~web/client';

export const createResaleListing = rxTask<SecondaryExchangeOfferGroupRequest, OfferGroupResponse>(
  (request: SecondaryExchangeOfferGroupRequest) =>
    apiClient.resaleController.createResaleListing$(request),
);



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/interactor/resale/create-resale-listing.ts